<template>
  <div class="ut-config">
    <section v-for="grupo in grupos" :key="grupo.titulo" class="ut-config-grupo">
      <h3>{{ grupo.titulo }}</h3>
      <div class="ut-config-campos">
        <campo-utilitario v-for="campo in grupo.campos" :key="campo.campo" :campo="campo" :value="value[campo.campo]"
          :class="{ 'ut-config-amplio': campo.tipo === 'textarea' }" :catalogos="catalogos" :disabled="disabled" @input="cambiar(campo.campo, $event)" />
      </div>
    </section>
    <section v-for="tabla in tablas" :key="tabla.nombre" class="ut-config-tabla">
      <header><h3>{{ tabla.titulo }}</h3><v-btn icon :disabled="disabled || value[tabla.nombre].length >= 200" :aria-label="'Agregar ' + tabla.titulo" :title="'Agregar ' + tabla.titulo" @click="agregar(tabla)"><v-icon>mdi-plus</v-icon></v-btn></header>
      <div v-for="(fila, indice) in value[tabla.nombre]" :key="indice" class="ut-config-fila">
        <campo-utilitario v-for="campo in tabla.campos" :key="campo.campo" :campo="campo" :value="fila[campo.campo]"
          :catalogos="catalogos" :disabled="disabled" @input="cambiarCelda(tabla.nombre, indice, campo.campo, $event)" />
        <v-btn icon :disabled="disabled" :aria-label="'Quitar fila ' + (indice + 1)" title="Quitar fila" @click="quitar(tabla.nombre, indice)"><v-icon>mdi-delete-outline</v-icon></v-btn>
      </div>
      <p v-if="!value[tabla.nombre].length">Sin registros.</p>
    </section>
  </div>
</template>
<script>
import CampoUtilitario from './CampoUtilitario.vue';
const GRUPOS = [
  { titulo: 'Impresoras', campos: 'impresora_tickets impresora_etiquetas' },
  { titulo: 'Opciones de operacion', campos: 'principal_boleteria usa_firma_digital puede_modificar_capacidad_vehiculo_pv precio_recargos_editable pasar_sobrante_caja_siguiente_turno puede_leer_tickets_otro_usuario sumar_boletos_no_abordados_turno_anterior cobro_dieta_cierre_viaje cajera_puede_modificar_ficha_facturar cajera_puede_modificar_chofer_facturar recargos_envios_usados_como_articulos secuencia_cierrescajas_por_caja' },
  { titulo: 'Formatos y copias de impresion', campos: 'formato_cierre_caja copias_boleto copias_boleto_pequeno copias_factura_envio copias_etiqueta_envio copias_cierre_viaje copias_cierre_caja' },
  { titulo: 'Calculo y cobro de envios', campos: 'config_calculo_precios_envios monto_minimo monto_fijo_cobrar porcentaje_cuando_supera_minimo cobro_digitado cobro_libra cobro_pies cobro_valor cobro_asiento cobro_envio_interno' },
  { titulo: 'Comisiones y distribucion', campos: 'sindicato chofer comision_fija_boletos formato_deduccion_comisiones_boletos' },
  { titulo: 'Contabilidad', campos: 'pasar_boletos_contabilidad pasar_envios_contabilidad pasar_otras_ventas_contabilidad' },
  { titulo: 'Titulos y politicas', campos: 'titulo_ida titulo_vuelta mensaje_facturas_boleto mensaje_facturas_envio' },
];
const TABLAS = [
  { nombre: 'rangos', titulo: 'Rangos por valor declarado', campos: [
    { campo: 'minimo', titulo: 'Minimo', tipo: 'numero', min: 0 }, { campo: 'maximo', titulo: 'Maximo', tipo: 'numero', min: 0 }, { campo: 'porcentaje', titulo: 'Porcentaje', tipo: 'numero', min: 0, max: 100 },
  ] },
  { nombre: 'comisiones', titulo: 'Comisiones por parada', campos: [
    { campo: 'sucursal', titulo: 'Parada', tipo: 'select', catalogo: 'sucursales' }, { campo: 'comision', titulo: 'Comision', tipo: 'numero', min: 0 },
  ] },
];
export default {
  name: 'ConfiguracionUtilitario', components: { CampoUtilitario },
  props: { value: { type: Object, required: true }, campos: { type: Array, required: true }, catalogos: { type: Object, required: true }, vista: { type: String, default: 'config' }, disabled: Boolean },
  computed: {
    grupos() {
      if (this.vista && this.vista !== 'config') {
        const grupos = new Map();
        this.campos.forEach(c => {
          const titulo = c.grupo || 'Datos del registro';
          if (!grupos.has(titulo)) grupos.set(titulo, { titulo, campos: [] });
          grupos.get(titulo).campos.push(c);
        });
        return [...grupos.values()];
      }
      const pendientes = new Map(this.campos.map(c => [c.campo, c]));
      const grupos = GRUPOS.map(g => ({ titulo: g.titulo, campos: g.campos.split(' ').map(nombre => {
        const campo = pendientes.get(nombre); pendientes.delete(nombre); return campo;
      }).filter(Boolean) })).filter(g => g.campos.length);
      if (pendientes.size) grupos.push({ titulo: 'Otros ajustes', campos: [...pendientes.values()] });
      return grupos;
    },
    tablas() { return TABLAS.filter(t => Array.isArray(this.value[t.nombre])); },
  },
  methods: {
    cambiar(campo, valor) { this.$emit('input', { ...this.value, [campo]: valor }); },
    cambiarCelda(tabla, indice, campo, valor) { this.cambiar(tabla, this.value[tabla].map((fila, i) => i === indice ? { ...fila, [campo]: valor } : fila)); },
    agregar(tabla) { const fila = {}; tabla.campos.forEach(c => { fila[c.campo] = ''; }); this.cambiar(tabla.nombre, [...this.value[tabla.nombre], fila]); },
    quitar(tabla, indice) { this.cambiar(tabla, this.value[tabla].filter((f, i) => i !== indice)); },
  },
};
</script>
<style scoped>
.ut-config-campos { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px; }
.ut-config-grupo + .ut-config-grupo { margin-top: 24px; padding-top: 18px; border-top: 1px solid #d5dce1; }
.ut-config-grupo h3 { margin: 0 0 18px; font-size: 15px; font-weight: 700; letter-spacing: 0; }
.ut-config-amplio { grid-column: 1 / -1; }
.ut-config-tabla { border-top: 1px solid #d5dce1; margin-top: 20px; padding-top: 12px; }
.ut-config-tabla header { display: flex; justify-content: space-between; align-items: center; gap: 12px; }
.ut-config-tabla h3 { font-size: 15px; letter-spacing: 0; }
.ut-config-fila { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)) 40px; gap: 8px; margin: 12px 0; }
@media (max-width: 600px) { .ut-config-campos { grid-template-columns: 1fr; } .ut-config-fila { grid-template-columns: minmax(0, 1fr); border-bottom: 1px solid #d5dce1; padding-bottom: 12px; } }
</style>
